export default {
  appConfig: {
    baseApiUrl: "/globus/api/",
  },
  devScripts: [
    "https://personal-area.dev.globus.center/js/app.js",
    "https://personal-area.dev.globus.center/js/chunk-vendors.js",
  ],
  stageScripts: [
    "https://personal-area.stage.globus.center/js/app.js",
    "https://personal-area.stage.globus.center/js/chunk-vendors.js",
  ],
  prodScripts: [
    "https://personal-area.globus.center/js/app.js",
    "https://personal-area.globus.center/js/chunk-vendors.js",
  ],
  settings: {
    module: "module_globus",
    path: "/news",
    routing: [
      {
        id: "map",
        icon: "map",
        route: "/map",
        text_ru: "карта",
        disabled: false
      },
      {
        id: "pulse",
        icon: "pulse",
        route: "/pulse",
        text_ru: "пульс",
        disabled: false
      },
      {
        id: "news",
        icon: "news",
        route: "/news",
        text_ru: "новости",
        disabled: false
      },
      {
        id: "analytics",
        icon: "analytics",
        route: "/country-data/analytics",
        active: "/country-data",
        text_ru: "аналитика",
        disabled: false
      },
      {
        id: "sources",
        icon: "sources",
        route: "/project-sources",
        active: "/project-sources",
        text_ru: "источники",
        disabled: false
      },
    ],
  },
  themesAlwaysEnabled: true,
};
